export const colors = {
  black: "#0d0d0d",
  yellow: "#fcc066",
  white: "#fff",
  grey: "#231F20",
  orange: "#ff8e00",
};
